var map = {
	"./de.json": [
		29530,
		530
	],
	"./en.json": [
		63192,
		192
	],
	"./fr.json": [
		54872,
		872
	],
	"./it.json": [
		31424,
		424
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 37096;
module.exports = webpackAsyncContext;